/**
 *
 * UsersDxGridContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectRoles } from 'domain/User/selectors';
import * as actionCreators from './actions';


class UsersDxGridContainer extends React.PureComponent {

  handleRowDoubleClick = (record) => this.props.executeEditAction(record.id);

  handleActionExecuting = (actionName, ids) => {
    switch (actionName) {
      case 'add':
        this.props.executeAddAction();
        break;

      case 'edit':
        this.props.executeEditAction(ids[0]);
        break;

      case 'view':
        this.props.executeViewAction(ids[0]);
        break;

      case 'close':
        this.props.executeCloseAction(ids);
        break;

      default:
        throw new Error('Executed a unknown action.');
    }
  };

  render() {
    const { component, viewName, roles } = this.props;
    return React.cloneElement(component, {
      viewName,
      onActionExecuting: this.handleActionExecuting,
      onRowDoubleClick: this.handleRowDoubleClick,
      roles,
    });
  }
}

UsersDxGridContainer.propTypes = {
  component: PropTypes.node.isRequired,
  viewName: PropTypes.string.isRequired,
  executeAddAction: PropTypes.func.isRequired,
  executeEditAction: PropTypes.func.isRequired,
  executeViewAction: PropTypes.func.isRequired,
  executeCloseAction: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  roles: makeSelectRoles(),
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersDxGridContainer);
